/**
 * Account creation status Enumerator.
 *
 * imported from
 * https://bitbucket.org/exporodev/exporo_baader_bank/src/master/application/app/Baader/Order/Enum/Status.php
 */

const OrderStatusEnum = Object.assign({
  NEW: 'new',
  SENT: 'sent',
  // SUCCESS: 'success',
});

Object.freeze(OrderStatusEnum);

export default OrderStatusEnum;



// WEBPACK FOOTER //
// ./src/enum/baader/OrderStatus.js